// @ts-nocheck
import { combineReducers } from 'redux';
import { VerifyEmailReducer } from "./Verify_Email/Verify_Email_Reducer";
import { SendCodeReducer } from "./Send_Code/Send_Code_Reducer";
import { PreferencesReducer } from "./Preferences/Preferences_Reducer";
import { VerifyCodeReducer } from "./Verify_Code/Verify_Code_Reducer";
import { UserDetailsReducer } from './User_Details/User_Details_Reducer';
import { HistoryReducer } from './History/History_Reducer';
import { FeaturePreviewsReducer } from './Feature_Previews/Feature_Previews_Reducer';
import { UpdateInterestReducer } from './Update_Interest/Update_Interest_Reducer';
import { UsageStatsReducer } from './Usage_Stats/Usage_Stats_Reducer';
import { FeatureRequestFeedbackReducer } from './Feedback/Feedback_Reducer';
import { RequiredListReducer } from './Required_List/Required_List_Reducer';
import { RecentListReducer } from './Recent_List/Recent_List_Reducer';
import { ReleaseNotesListReducer } from './Release_Notes_List/Release_Notes_List_Reducer';
import { UpgradeRequestReducer } from './Upgrade_Request/Upgrade_Request_Reducer';
import { UpgradeRequestListReducer } from './Upgrade_Request/Upgrade_Request_List_Reducer';
import { FeatureRequestRequiredListReducer } from './Feature_Request_Required_List/Feature_Request_Required_List_Reducer';
import { FeatureRequestGetListReducer } from './Feature_Request_Get_List/Feature_Request_Get_List_Reducer';
import { ContactAdminReducer } from './Contact_Admin/Contact_Admin_Reducer';
import { VoteReducer } from './Vote/Vote_Reducer';
import { ProfileReducer } from './Profile/Profile_Reducer';
import { UpdateSupportContactReducer } from './UpdateSupportContact/UpdateSupportContact_Reducer';
import { CaseRequiredListReducer } from './Case_Required_List/Case_Required_List_Reducer';
import { CaseListReducer } from './Case_List/Case_List_Reducer';
import { CaseCommentsListReducer } from './Case_Comments_List/Case_Comments_List_Reducer';
import { CaseCommentsAddReducer } from './Case_Comments_Add/Case_Comments_Add_Reducer';
import { CaseCommentsAddReplyReducer } from './Case_Comments_Add_Reply/Case_Comments_Add_Reply_Reducer';
import { CaseUploadFileReducer } from './Case_Upload_File/Case_Upload_File_Reducer';
import { CaseCreateReducer } from './Case_Create/Case_Create_Reducer';
import { CaseCloseReducer } from './Case_Close/Case_Close_Reducer';
import { ChangeRequestRequiredListReducer } from './Change_Request_Required_List/Change_Request_Required_List_Reducer';
import { ChangeRequestListReducer } from './Change_Request_List/Change_Request_List_Reducer';
import { ChangeRequestCommentsListReducer } from './Change_Request_Comments_List/Change_Request_Comments_List_Reducer';
import { ChangeRequestCommentsAddReducer } from './Change_Request_Comments_Add/Change_Request_Comments_Add_Reducer';
import { ChangeRequestCommentsAddReplyReducer } from './Change_Request_Comments_Add_Reply/Change_Request_Comments_Add_Reply_Reducer';
import { ChangeRequestUploadFileReducer } from './Change_Request_Upload_File/Change_Request_Upload_File_Reducer';
import { CheckPackageVersionReducer } from './Check_Package_Version/Check_Package_Version_Reducer';
import { RequestHelpReducer } from './Request_Help/Request_Help_Reducer';
import { LicenseListReducer } from './License_And_Subscription/License_List_Reducer';
import { LicenseAdjustmentReducer } from './License_And_Subscription/License_Adjustment_Reducer';
import { ProductListReducer } from './Product_Engagement/Product_List_Reducer';
import { CreateEngagementReducer } from './Product_Engagement/Create_Engagement_Reducer';

const reducer = combineReducers({
    VerifyEmailReducer,
    SendCodeReducer,
    PreferencesReducer,
    VerifyCodeReducer,
    UserDetailsReducer,
    HistoryReducer,
    FeaturePreviewsReducer,
    UpdateInterestReducer,
    UsageStatsReducer,
    RequiredListReducer,
    RecentListReducer,
    ReleaseNotesListReducer,
    UpgradeRequestReducer,
    UpgradeRequestListReducer,
    FeatureRequestRequiredListReducer,
    FeatureRequestGetListReducer,
    ContactAdminReducer,
    FeatureRequestFeedbackReducer,
    VoteReducer,
    ProfileReducer,
    UpdateSupportContactReducer,
    CaseRequiredListReducer,
    CaseListReducer,
    CaseCommentsListReducer,
    CaseCommentsAddReducer,
    CaseCommentsAddReplyReducer,
    CaseUploadFileReducer,
    CaseCreateReducer,
    CaseCloseReducer,
    ChangeRequestRequiredListReducer,
    ChangeRequestListReducer,
    ChangeRequestCommentsListReducer,
    ChangeRequestCommentsAddReducer,
    ChangeRequestCommentsAddReplyReducer,
    ChangeRequestUploadFileReducer,
    CheckPackageVersionReducer,
    RequestHelpReducer,
    LicenseListReducer,
    LicenseAdjustmentReducer,
    ProductListReducer,
    CreateEngagementReducer
})

export default reducer;